import { OfferMessageStepView, OfferNotificationMessagePanel } from '@today/ui-domain'
import { Link, useParams } from 'react-router-dom'
import { useOfferNotificationMessage } from '@/modules/offer-notification/useOfferNotificationMessage'
import { MESSAGE_MAX, useOfferMessageStep } from '@/modules/offer-wizard/useOfferMessageStep'

/** `/offers/:offerId/message` — Offer Wizard Step 3, message + live landing preview (TO-124) and the customer notification message (TO-140). */
export function OfferMessagePage() {
	const { offerId = '' } = useParams()
	const step = useOfferMessageStep(offerId)
	const notification = useOfferNotificationMessage(offerId, step.locale)

	if (step.loadFailed) {
		return (
			<p role="alert" className="text-sm text-ds-danger">
				Could not load this offer.
			</p>
		)
	}
	if (step.loading) {
		return (
			<p className="text-sm text-ds-text-muted" aria-live="polite">
				Loading offer…
			</p>
		)
	}
	return (
		<section className="flex flex-col gap-4">
			<h1 className="text-xl font-semibold">Step 3 — Message</h1>
			<OfferMessageStepView
				message={step.message}
				maxLength={MESSAGE_MAX}
				locale={step.locale}
				localeOptions={step.localeOptions}
				readOnly={step.readOnly}
				saveStatus={step.saveStatus}
				previewHtml={step.previewHtml}
				previewError={step.previewError}
				onMessageChange={step.setMessage}
				onLocaleChange={step.setLocale}
			/>
			<OfferNotificationMessagePanel {...notification} />
			<nav className="flex justify-between text-sm">
				<Link to={`/offers/${encodeURIComponent(offerId)}/products`}>← Step 2 — Products</Link>
				<Link to={`/offers/${encodeURIComponent(offerId)}`}>Continue to the offer →</Link>
			</nav>
		</section>
	)
}
